
import React from 'react';
import { Button } from '@/components/ui/button';
import { 
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const OfferCtaSection = () => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">What's Included In Cold Email Secrets $100 Tier:</h2>
      
      <Accordion type="single" collapsible className="w-full mb-8">
        <AccordionItem value="item-1" className="border-b border-blue-200">
          <AccordionTrigger className="text-xl font-bold text-blue-700 hover:text-blue-800 py-4">
            Proven Templates & Infrastructure
          </AccordionTrigger>
          <AccordionContent className="text-gray-700 pb-6">
            <ul className="list-disc pl-6 space-y-3">
              <li><span className="font-medium">Revenue-Generating Templates:</span> Access our 20/80 email templates that have generated thousands of appointments without modification</li>
              <li><span className="font-medium">Enterprise-Level Infrastructure:</span> Our proprietary High IP/High Domain strategy allows for 100,000+ daily emails with minimal warm-up time</li>
              <li><span className="font-medium">Premium Data at Fraction of Cost:</span> Direct connections to our trusted vendors providing identical quality data at 1/30th the industry rate ($300 vs $10,000 per million records)</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-2" className="border-b border-blue-200">
          <AccordionTrigger className="text-xl font-bold text-blue-700 hover:text-blue-800 py-4">
            Conversion-Optimized Systems
          </AccordionTrigger>
          <AccordionContent className="text-gray-700 pb-6">
            <ul className="list-disc pl-6 space-y-3">
              <li><span className="font-medium">Maximum Personalization:</span> Simple drag-and-drop process for creating highly personalized "handwritten" emails that convert</li>
              <li><span className="font-medium">Sales Call Excellence:</span> Recordings of our most successful sales calls with step-by-step instructions to adapt your approach for cold email prospects</li>
              <li><span className="font-medium">Instant Booking Solution:</span> High-converting booking page template—just add your offer details and start receiving appointments immediately</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-3" className="border-b border-blue-200">
          <AccordionTrigger className="text-xl font-bold text-blue-700 hover:text-blue-800 py-4">
            Operational Excellence
          </AccordionTrigger>
          <AccordionContent className="text-gray-700 pb-6">
            <ul className="list-disc pl-6 space-y-3">
              <li><span className="font-medium">Troubleshooting Mastery:</span> Learn to interpret common high-volume email errors and implement immediate fixes to keep appointments flowing</li>
              <li><span className="font-medium">Campaign Revitalization:</span> The 5 key levers for breathing new life into your lead list when appointment volume declines</li>
              <li><span className="font-medium">Agency-Ready Systems:</span> Complete operating templates we use to train and scale our email marketing agency</li>
            </ul>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value="item-4" className="border-b border-blue-200">
          <AccordionTrigger className="text-xl font-bold text-blue-700 hover:text-blue-800 py-4">
            Technical Implementation
          </AccordionTrigger>
          <AccordionContent className="text-gray-700 pb-6">
            <ul className="list-disc pl-6 space-y-3">
              <li><span className="font-medium">Tool Optimization:</span> Comprehensive Gmass + Smartlead implementation guide (our preferred tools for high-volume sending)</li>
              <li><span className="font-medium">Target Selection Strategy:</span> Data targeting methodology to minimize bounces and ensure marketing alignment</li>
              <li><span className="font-medium">Rapid Revenue Blueprint:</span> The exact playbook that generated $120K by month 3 using cold email (results may vary)</li>
              <li><span className="font-medium">Infrastructure Options:</span> Our "Infrastructure Buffet" breaks down the pros and cons of various mailbox configurations</li>
              <li><span className="font-medium">Scale-Ready Solutions:</span> Connections to our elite email infrastructure vendors capable of supporting 300,000+ emails daily (we've achieved 1.5M in a single day)</li>
              <li><span className="font-medium">DIY Server Setup:</span> Technical guide for configuring your own servers with postfix, dovecot, and cursor.ai</li>
            </ul>
          </AccordionContent>
        </AccordionItem>
      </Accordion>

      <div className="mt-8 text-center">
        <a href="https://whop.com/checkout/plan_lgxEwNdJ45OQ3?d2c=true" target="_blank" rel="noopener noreferrer">
          <Button 
            className="w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 text-lg"
          >
            BUY NOW
          </Button>
        </a>
      </div>
    </div>
  );
};

export default OfferCtaSection;
